import { Link } from 'react-router-dom';

export default function CTABanner() {
  return (
    <section className="py-14 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20cozy%20abstract%20background%20with%20soft%20golden%20amber%20glowing%20gradients%2C%20artistic%20warmth%20concept%2C%20gentle%20texture%20like%20soft%20wool%20and%20cashmere%2C%20minimalist%20elegant%20design%2C%20warm%20cream%20to%20amber%20color%20palette%2C%20peaceful%20comforting%20atmosphere&width=1920&height=600&seq=cta-banner-rejiujiu&orientation=landscape"
          alt="热久久 - 开启温暖之旅"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-secondary-900/90 to-secondary-900/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[700px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-3 font-heading">
            准备好迎接温暖了吗？
          </h2>
          <p className="text-sm md:text-base text-background-50/70 mb-8">
            选择热久久，让每一次寒冷都变成温暖记忆。立即探索最适合您的保暖方案。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/categories"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap"
            >
              立即选购
              <i className="ri-shopping-bag-line ml-2"></i>
            </Link>
            <Link
              to="/about"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 hover:bg-background-50/25 backdrop-blur-sm text-background-50 rounded-lg text-sm font-medium transition-all duration-200 border border-background-50/30 whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}